module.exports = __webpack_public_path__ + "media/landing_page/accent_brick-7c87d519.svg";